var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOriginalDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 14.4167H11.5833V0.25H0.25V14.4167ZM0.25 25.75H11.5833V17.25H0.25V25.75ZM14.4167 25.75H25.75V11.5833H14.4167V25.75ZM14.4167 0.25V8.75H25.75V0.25H14.4167Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginalDuration);
export default __webpack_public_path__ + "static/media/Original-Duration.99876c76faea932d1efd81fb5ce31f1b.svg";
export { ForwardRef as ReactComponent };